export default "__VITE_ASSET__BO6b8R0K__"